/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum OrderStatusFilter {
  NOT_SCHEDULED="NOT_SCHEDULED",
SCHEDULED="SCHEDULED",
DELIVERED="DELIVERED",
MISSED="MISSED"
}

/**
* OrderStatusFilter
*/
export const OrderStatusFilterEnumType = types.enumeration("OrderStatusFilter", [
        "NOT_SCHEDULED",
  "SCHEDULED",
  "DELIVERED",
  "MISSED",
      ])
